import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../../../PageHeader';
import CorporateSectionLayout from '../../../CorporateSectionLayout';
import Gratifikasi from './Gratifikasi';
import BenturanKepentingan from './BenturanKepentingan';

function GratifikasiBenturanKepentinganLayout() {
    const items = [
        { id: 'gratifikasi', number: '01', label: 'Gratifikasi', content: <Gratifikasi /> },
        { id: 'benturan-kepentingan', number: '02', label: 'Benturan Kepentingan', content: <BenturanKepentingan /> },
    ];
    return <>
        <Helmet><title>Gratifikasi & Benturan Kepentingan | PT Len Telekomunikasi Indonesia</title><meta name="description" content="Gratifikasi & Benturan Kepentingan PT Len Telekomunikasi Indonesia." /><link rel="canonical" href="https://www.len-telko.co.id/tata-kelola-perusahaan/gratifikasi-benturan-kepentingan" /></Helmet>
        <PageHeader title="Gratifikasi & Benturan Kepentingan" />
        <CorporateSectionLayout title="Gratifikasi & Benturan Kepentingan" eyebrow="Tata Kelola Perusahaan" items={items} />
    </>;
}
export default GratifikasiBenturanKepentinganLayout;
